<template>
  <div class="view view--mole">
    <ui-headline v-if="record.headline" :record="record.headline"/>
    <ui-counter :amount="amount" :record="record.headline"/>
    <div class="view__body-container" :style="style">
      <ui-mole-view
        :moles="moles"
        :speedMin="speedMin"
        :speedMax="speedMax"
        :time="time"
        :hole-image="holeImage"
        :hideout-time-ratio="hideoutTimeRatio"
      />
    </div>
  </div>
</template>
<script>
import { StyleMixin, TimeMixin } from '@/mixins';
import UiCounter from '@/components/ui-counter/index.vue';
import UiHeadline from '@/components/ui-headline/index.vue';
import UiMoleView from '@/components/ui-mole/ui-mole-view.vue';
import { addQuest } from '@/app/state';

export default {
  components: {
    UiCounter,
    UiHeadline,
    UiMoleView,
  },
  mixins: [
    StyleMixin,
    TimeMixin,
  ],
  props: {
    record: {
      type: Object,
      required: true,
    },
    amount: Number,
  },
  data() {
    return {
      speedMin: parseFloat(this.record.speedMin),
      speedMax: parseFloat(this.record.speedMax),
      hideoutTimeRatio: parseFloat(this.record.hideoutTimeRatio || 2.5),
      moles: this.record.body.moles,
      time: this.record.questTime,
      holeImage: this.record.body.holeImage,
      questFuse: 1000,
    };
  },
  mounted() {
    addQuest({ testId: this.record.testId, type: this.record.type });
  },
};
</script>
